window.application.register("modal-trigger", 
	class extends Stimulus.Controller {
		//loading frame example. loads on modal show
		// <a data-controller="modal-trigger"
		// data-action="modal-trigger#show">
		// 	Learn more
		// 	<template data-target="modal-trigger.modal">
		// 		<div 
		// 		data-controller="events frame"
		// 		data-events-sse-url="<%=baseUrl%>/events/talks"
		// 		data-events-sse-events="refresh"
		// 		data-frame-url="<%=baseUrl%>/frames/talk/<%=talk._id%>"
		// 		data-frame-init="true"
		// 		data-action="sse:refresh->frame#load"
		// 		></div>								
		// 	</template>
		// </a>

		//loading frame example. preloads even before showing in modal
		// <a data-controller="modal-trigger"
		// data-action="modal-trigger#show">
		// 	Learn more
		// 	<template data-target="modal-trigger.modal
		// 	data-controller="events frame"
		// 	data-events-sse-url="<%=baseUrl%>/events/talks"
		// 	data-events-sse-events="refresh"
		// 	data-frame-url="<%=baseUrl%>/frames/talk/<%=talk._id%>"
		// 	data-frame-init="true"
		// 	data-action="sse:refresh->frame#load">
		//	</template>
		//  </a>

		//loading basic element example
		// <a data-controller="modal-trigger"
		// data-action="modal-trigger#show">
		// 	Learn more
		// 	<template data-target="modal-trigger.modal
		//	<div class="p-6 bg-white">asdaskdasdlaksdjl</div>
		//	</template>
		//  </a>

		//loading element based on ID
		//<div id="divId">content</div>
		// <a data-controller="modal-trigger"
		// data-action="modal-trigger#show">
		// data-modal-trigger-id="divID"
		// 	Learn more
		//  </a>

		//Placing modal in the context of a template. modal becomes a sibling of the modal-trigger element
		// <a 
        //  data-controller="modal-trigger"
        //  data-modal-trigger-use-context="true"
        //  data-modal-trigger-clone="false" (default is true)
        //  data-modal-trigger-hide-close-btn="true" (default is false)
        //  data-action="click->modal-trigger#show">Add
        //    <template data-target="modal-trigger.modal">
        //        <div>
        //        content
        //        </div>
        //    </template>
        //   </a>

        //by default, the modal content is cloned
        //if you don't want to clone, add data-modal-trigger-clone="false" to the element

		static get targets() {
		  return ["modal"]
		}

		connect(){
			this.element[this.identifier] = this;
			window.addEventListener('modal:closed', this.onClosed.bind(this));
			window.addEventListener('modal:opened', this.onOpened.bind(this));
		}

		onClosed(e){
			if(e.trigger == this){
				if(this.data.get('clone') == "false" && this.content && this.contentParent){
					this.contentParent.insertBefore(this.content, this.placeholder);
					this.contentParent.removeChild(this.placeholder);
				}
				var event = new CustomEvent("modal-trigger:closed");
				this.element.dispatchEvent(event);
			}
		}

		onOpened(e){
			if(e.trigger == this){
				if(this.data.get('hideCloseBtn') == "true"){
					window.modal.hideCloseBtn();
				}
				var event = new CustomEvent("modal-trigger:opened");
				this.element.dispatchEvent(event);
			}
		}

		show(e){
			var templateContent;
			if(e && e.currentTarget.dataset.modalTriggerId && document.getElementById(e.currentTarget.dataset.modalTriggerId)){
				if(this.data.get('clone') == "false")
				{
					templateContent = document.getElementById(e.currentTarget.dataset.modalTriggerId);
					this.content = templateContent;
					this.contentParent = templateContent.parentNode;
					this.placeholder = this.contentParent.insertBefore(document.createElement("div"), this.content);
				}else{
					templateContent = document.importNode(document.getElementById(e.currentTarget.dataset.modalTriggerId), true);
				}
			}else if(this.hasModalTarget){
				if(this.data.get('clone') == "false")
				{
					templateContent = this.modalTarget.content;
				}else{
					templateContent = document.importNode(this.modalTarget.content, true);
				}				
			}
			if(this.data.get('useContext') == "true"){
				window.modal.show(templateContent, this.element.parentNode, this);						
			}else{
				window.modal.show(templateContent, null, this);	
			}
		}

		disconnect(){
			// try{
				this.tearDown();
			// }catch(err){}
		}

		tearDown(){
			try{window.removeEventListener('modal:opened', this.onOpened.bind(this));}catch(err){}
			try{window.removeEventListener("modal:closed", this.onClosed.bind(this));}catch(err){}
		}
	}
)